package pl.finn.forms.enums

enum class BindedAs {
  FIRST_CHILD, NEXT_SIBLING;

  override fun toString(): String {
    return name
  }
}
